import {
	ALTERAR_TENANT_ATUAL,
	TENANT_KEY,
	UPDATE_TENANTS,
} from "redux/constants/Tenant";

const initTenants = {
	tenants: [],
	tenantAtual: localStorage.getItem(TENANT_KEY),
};

const tenants = (state = initTenants, action) => {
	switch (action.type) {
		case UPDATE_TENANTS:
			return {
				...state,
				tenants: action.tenants,
			};
		case ALTERAR_TENANT_ATUAL:
			localStorage.setItem(TENANT_KEY, action.tenantAtual);
			return {
				...state,
				tenantAtual: action.tenantAtual,
			};
		default:
			return state;
	}
};

export default tenants;
